import UserPage from "src/pages/User";
import { getUserInitialProps } from "src/utilities/ssr/getUserInitialProps";
import {
  getUserInfo,
  getUserPageDonationsFeed,
} from "src/utility/apiClient/usernamePage";

UserPage.getInitialProps = getUserInitialProps(
  getUserInfo(getUserPageDonationsFeed, "donationsFeed")
);

export default UserPage;
